import React from 'react'
import { View, Text, StyleSheet } from 'react-native';
import { BigBodyGroup } from 'fitbeat.gym-core';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import { defaultScale, graphScaleLine, fullScale, scaleText } from '../../utils/scaling';

const isSmallMobile = window.innerWidth <= 350;
class TargetedMuscleGroupBar extends React.PureComponent {
    render() {
        const { backAndArms, upperAndArms, lower } = this.props.muscleGroupPercentages;
        const { t } = this.props
        return (
            <View style={styles.container}>
                <View style={styles.barContainer}>
                    <View style={[styles.backAndArmsBar, { height: defaultScale(backAndArms ? backAndArms + 15 : 15), }]} />
                    <View style={[styles.upperBodyBar, { height: defaultScale(upperAndArms ? upperAndArms + 15 : 15) }]} />
                    <View style={[styles.lowerBodyBar, { height: defaultScale(lower ? lower + 15 : 0) }]} />
                </View>
                <View style={styles.barDescriptionContainer}>
                    <View >
                        <Text style={styles.percentageText}>{`${backAndArms ? backAndArms : 0}%`}</Text>
                        <Text style={styles.descriptionText}>{BigBodyGroup.BackAndArms}</Text>
                    </View>
                    <View >
                        <Text style={styles.percentageText}>{`${upperAndArms ? upperAndArms : 0}%`}</Text>
                        <Text style={styles.descriptionText}>{t('bodyGroup', { bodyGroup: BigBodyGroup.Upper })}</Text>
                    </View>
                    <View >
                        <Text style={styles.percentageText}>{`${lower ? lower : 0}%`}</Text>
                        <Text style={styles.descriptionText}>{t('bodyGroup', { bodyGroup: BigBodyGroup.Lower })}</Text>
                    </View>
                </View>
            </View>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        flex: 1
    },
    barContainer: {
        marginRight: defaultScale(10),
        flexDirection: 'column',
        justifyContent: 'flex-start',
    },
    barDescriptionContainer: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'space-around',
    },
    percentageText: {
        ...Theme.textStyle.bodyCopyReg,
        color: Theme.GREY_DARK,
    },
    descriptionText: {
        color: Theme.GREY_MEDIUM,
        fontSize: isSmallMobile ? scaleText(10) : scaleText(14)
    },
    backAndArmsBar: {
        width: defaultScale(10),
        backgroundColor: Theme.GREY_DARK,
        borderTopStartRadius: defaultScale(40),
        borderTopEndRadius: defaultScale(40),
        borderTopColor: Theme.WHITE,
        borderTopWidth: defaultScale(1),
        borderRightColor: Theme.WHITE,
        borderRightWidth: defaultScale(1),
        borderLeftColor: Theme.WHITE,
        borderLeftWidth: defaultScale(1)
    },
    upperBodyBar: {
        width: defaultScale(10),
        backgroundColor: Theme.GREY_DARK_MEDIUM,
        borderRightColor: Theme.WHITE,
        borderRightWidth: defaultScale(1),
        borderLeftColor: Theme.WHITE,
        borderLeftWidth: defaultScale(1)
    },
    lowerBodyBar: {
        width: defaultScale(10),
        backgroundColor: Theme.GREY_MEDIUM_LIGHT,
        borderBottomStartRadius: defaultScale(40),
        borderBottomEndRadius: defaultScale(40),
        borderRightColor: Theme.WHITE,
        borderRightWidth: defaultScale(1),
        borderLeftColor: Theme.WHITE,
        borderLeftWidth: defaultScale(1)
    }
});
export default translate(['bookings'], { wait: true })(TargetedMuscleGroupBar);